import { useState } from "react";
import { Loader2 } from "lucide-react";
import { fileUrl } from "../../lib/api";

const BGS = [
  ["checkerboard", "Checker", "bg-checker"],
  ["black", "Black", "bg-black"],
  ["white", "White", "bg-white"],
];

const StageContent = ({ mode, logo, still, video }) => {
  if (mode === "video" && video.status === "done") {
    return (
      <video data-testid="main-video-preview" key={video.id} src={fileUrl(video.files.webm)}
        autoPlay loop muted playsInline className="w-full h-full object-contain" />
    );
  }
  if (mode === "video") {
    return (
      <div className="flex flex-col items-center gap-3 text-gray-300" data-testid="stage-video-pending">
        {video.status === "failed" ? <span className="text-red-300 text-sm px-8 text-center">{video.error}</span>
          : <><Loader2 className="w-6 h-6 animate-spin text-[#00ff87]" /><span className="text-sm">Video rendering…</span></>}
      </div>
    );
  }
  if (mode === "still") {
    return <img data-testid="stage-still-img" src={fileUrl(still.path)} alt="Chrome still" className="w-full h-full object-contain" />;
  }
  return logo ? (
    <img data-testid="stage-logo-img" src={fileUrl(logo.path)} alt="Logo" className="w-3/4 h-3/4 object-contain opacity-80" />
  ) : null;
};

export const PreviewStage = (props) => {
  const [bg, setBg] = useState("checkerboard");
  const label = { video: "Loop preview · transparent", still: "Chrome still", logo: "Source logo" }[props.mode];
  return (
    <div className="rise">
      <div className="flex items-end justify-between mb-4 gap-4 flex-wrap">
        <div>
          <div className="font-mono-ui text-[11px] uppercase tracking-[0.2em] text-emerald-400/80">Stage · 16:9</div>
          <div data-testid="stage-label" className="font-display font-bold text-xl mt-1">{label}</div>
        </div>
        <div className="glass rounded-full p-1 flex gap-1" data-testid="bg-toggle">
          {BGS.map(([k, name]) => (
            <button key={k} data-testid={`bg-toggle-${k}`} onClick={() => setBg(k)}
              className={`px-4 py-1.5 rounded-full text-xs font-mono-ui uppercase tracking-wider transition-colors ${bg === k ? "bg-[#00ff87] text-[#041b10]" : "text-gray-400 hover:text-white"}`}>
              {name}
            </button>
          ))}
        </div>
      </div>
      <div data-testid="preview-stage"
        className={`${BGS.find((b) => b[0] === bg)[2]} relative aspect-video w-full rounded-2xl overflow-hidden border border-[#1e2638] flex items-center justify-center shadow-[0_40px_120px_-40px_rgba(0,255,135,0.25)]`}>
        <StageContent {...props} />
      </div>
      <p className="text-xs text-gray-500 mt-3">The transparent preview plays in Chrome, Edge and Firefox. Safari can't show see-through WebM, so use the MOV there.</p>
    </div>
  );
};
